import { render } from "./FrmExpeditionDocument.vue?vue&type=template&id=525d4a50"
import script from "./FrmExpeditionDocument.vue?vue&type=script&lang=js"
export * from "./FrmExpeditionDocument.vue?vue&type=script&lang=js"

import "./FrmExpeditionDocument.vue?vue&type=style&index=0&id=525d4a50&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__